/*
 * @Author: wufan 
 * @Date: 2019-08-20 10:32:12 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: yyyy-11-Tu 01:52:02
 * 帮助中心-侧边栏菜单
 */

import React, { useEffect, useState } from 'react';
import './Menu.less';
import { Menu } from 'antd';
import AxiosTS from '../../core/axios';
import {
  withRouter
} from 'react-router-dom';
import BusTs from '../../core/TBus';
import XMTD from '../../core/xmTD';
import { getParameterByName } from '../../core/function'

const { SubMenu } = Menu;


const MenuPage: React.FC = (props: any) => {

  // 获取选中的subMenu和menu项
  const defaultOpenKeys = props.location.pathname.indexOf("entry/") !== -1 ?
    props.location.pathname.slice(props.location.pathname.indexOf('/', 5) + 1) : "";
  const defaultSelectedKeys = props.location.pathname.indexOf("detail/") !== -1 ?
    props.location.pathname.slice(props.location.pathname.indexOf('/', 5) + 1) : "";

  const [openKeys, setOpenKeys] = useState(defaultOpenKeys); // 当前展开的 SubMenu 菜单项 key 数组
  const [selectedKeys, setSelectedKeys] = useState(defaultSelectedKeys);// 当前选中的菜单项 key 数组

  const [subMenuData, setSubMenuData] = useState([]);// 获取SubMenu 菜单项数据


  const [menuData, setMenuData] = useState([]);// 获取menu.Item 的数据
  const [menuTotal, setMenuTotal] = useState(-1);// 获取menu.Item 的数据总数
  const [menuPageNo, setMenuPageNo] = useState(1);
  let newVersion = getParameterByName('newVersion') || localStorage.getItem('newVersion') || "";
  localStorage.setItem('newVersion', newVersion);

  useEffect(() => {
    let key = props.location.pathname.indexOf("detail/") !== -1 ?
      props.location.pathname.slice(props.location.pathname.indexOf('/', 5) + 1) : "";
    setSelectedKeys(key);
  }, [props.location.pathname])

  useEffect(() => {
    BusTs.addListener("initTotal", () => {
      setMenuTotal(-1);
      setMenuPageNo(1);
      setMenuData([]);
      setOpenKeys("")
    });
  }, [])

  // 根据路由选中对应的SubMenu和menu.item
  useEffect(() => {
    AxiosTS.sobot("query_doc_detail", {
      docId: selectedKeys,
      robotFlag: newVersion == 'true' ? 2 : 1,
    })
      .then((res: any) => {
        if (res.code === "1000") {
          setSelectedKeys(res.data.item.docId);
          setOpenKeys(res.data.item.questionTypeId);

        }
      })
      .catch((res: any) => {

      })

  }, [selectedKeys, newVersion])


  // 获取submenu列表 
  useEffect(() => {
    console.log(9999)
    const parentTypeId = newVersion == 'true' ? "d7052befaf024047adcb1cbd8443bf2a" : "3c6e87ce08b9486b806c6f675a56f5df"
    AxiosTS.sobot("search_question_type_list", {
      parentTypeId,
      robotFlag: newVersion == 'true' ? 2 : 1,
    })
      .then((res: any) => {
        if (res.code === "1000") {
          setSubMenuData(res.data.items);
        }
      })
  }, [newVersion])



  // 获取menu.Item列表
  useEffect(() => {
    menuData.length !== menuTotal && openKeys &&
      AxiosTS.sobot("search_doc_list", {
        questionTypeId: openKeys,
        robotFlag: newVersion == 'true' ? 2 : 1,
        keyFlag: 1,
        pageNo: menuPageNo,
        usedFlag: 0
      })
        .then((res: any) => {
          if (res.code === "1000") {
            let data: never[] = menuData.concat(res.data.items);
            let sortList: never[] = sortData(data);
            setMenuData(sortList);
            setMenuTotal(res.data.totalCount);
            setMenuPageNo(preNo => preNo + 1);
          }
        })
  }, [openKeys, menuPageNo, newVersion])

  // 跳转到问题详情页
  function changeDocRouter(docId: string) {
    setSelectedKeys(docId);
    props.history.push({
      pathname: `/detail/${docId}`,
    })
  }

  function XMDataDot(item: any) {
    let paramList: any = JSON.parse(localStorage.getItem("ParamsFromB") ||
      "");
    paramList.name = "B端-点击-帮助中心详情";
    paramList.docId = item.docId;
    paramList.questionTitle = item.questionTypeName + "——" + item.questionTitle;
    XMTD(paramList);
  }

  function renderChildren(questionTypeId: string) {
    return menuData.map((item: any, index: number) => {
      return <Menu.Item
        key={item.docId}
        className={selectedKeys == item.docId ? "active" : ""}
        onClick={() => {
          changeDocRouter(item.docId);
          XMDataDot(item);
        }}
      >
        {item.questionTitle}
      </Menu.Item>
    })
  }

  function changeRouter(questionTypeId: string) {
    // 重置为可以发送请求的初始状态
    setOpenKeys(questionTypeId);
    setSelectedKeys('');
    setMenuTotal(-1);
    setMenuPageNo(1);
    setMenuData([]);

    props.history.push({
      pathname: `/entry/${questionTypeId}`,
    })
  }

  // 重置为可以发送请求的初始状态
  function initKeys() {
    setOpenKeys('');
    setSelectedKeys('');
    setMenuTotal(-1);
    setMenuPageNo(1);
    setMenuData([]);
  }

  // 渲染SubMenu树
  function renderTree() {
    return subMenuData.map((item: any, index: number) => {
      return <SubMenu
        onTitleClick={() => {
          openKeys === item.questionTypeId ?
            initKeys() : changeRouter(item.questionTypeId);
        }}
        key={item.questionTypeId}
        title={
          <span>
            <span>{item.questionTypeName}</span>
          </span>
        }
        className={openKeys === item.questionTypeId && !selectedKeys ? "active" : ""}
      >
        {renderChildren(item.questionTypeId)}
      </SubMenu>
    })
  }

  // 按数字序号从小到大排序
  function sortData(arr: never[]) {

    let newArr = arr.sort((a: { questionTitle: string }, b: { questionTitle: string }): any => {
      let AQuestionTitle = a.questionTitle;
      let BQuestionTitle = b.questionTitle;
      let firstNumbers = AQuestionTitle.slice(0, AQuestionTitle.indexOf("#"));
      let secondNumbers = BQuestionTitle.slice(0, BQuestionTitle.indexOf("#"));
      return Number(firstNumbers) - Number(secondNumbers)
    })
    return newArr;
  }

  return (
    <div className="menu-page">
      <div className="box">
        <Menu
          style={{ width: '300px' }}
          openKeys={[openKeys]}
          selectedKeys={[selectedKeys]}
          mode="inline"
        >
          {renderTree()}
        </Menu>
      </div>
    </div>
  )
}

export default withRouter(MenuPage);

